/**
 * Forgotten Forest dividida por faixas de Z. Resolve em que região o player está
 * (para o HUD e a música) e desenha bandas de chão sutis para dar leitura de zona.
 * A geografia vem 100% do GameConfig.regions (fonte única).
 */
import * as THREE from "three";
import { GameConfig } from "../config/GameConfig";

export type RegionId = "forestEntrance" | "voidClearing" | "corruptedGrove" | "alphaDen";

const REGION_TINT: Record<RegionId, number> = {
  forestEntrance: 0x1a2a16,
  voidClearing: 0x17200f,
  corruptedGrove: 0x2a1420,
  alphaDen: 0x1a1030,
};

export class Regions {
  readonly group = new THREE.Group();

  constructor(scene: THREE.Scene) {
    // 10.5M — as bandas de Z saíram do VISUAL: quem dá cor/identidade ao chão agora é o
    // TERRITÓRIO (Arena). Esta classe segue existindo só como lógica (região por Z).
    // O grupo continua no cenário (vazio) para o RegionManager ligar/desligar sem exceção.
    void REGION_TINT;
    scene.add(this.group);
  }

  /** Região na coordenada Z informada. */
  regionAt(z: number): RegionId {
    for (const r of GameConfig.regions) {
      if (z >= r.zMin && z < r.zMax) return r.id as RegionId;
    }
    return "voidClearing";
  }

  /** Chave i18n do nome da região. */
  nameKey(id: RegionId): string {
    return `region.${id}`;
  }
}
